import React from 'react'

import { Formik } from 'formik'

import Yup from '_zari/validation/_yup'

import { ZariContext } from '_zari/context'

import { Col, Row, Portlet, Button, Divider } from '_zari/core'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'
import * as Tables from './tables'

const ValidationSchema = Yup.object().shape({
  _idSocio: Yup.string().notRequired()
})

const ConsultasCuentasCorrientesPage = () => {
  const __zariContext = React.useContext(ZariContext)

  const [listaDocumentos, setListaDocumentos] = React.useState([])

  const formInitialValues = React.useMemo(() => {
    return {
      _idSocio: '',
      codigoSocio: '',
      documentoSocio: '',
      nombreSocio: '',
      tipoDocumentoSocio: '',
      tipoSocio: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      __zariContext.loader.open('Consultando informacion con filtros ingresados.')

      AsientoContableService.consultaGeneralCuentasCorrientes(data)
        .then(({ data }) => {
          if (data) {
            setListaDocumentos(data)
          } else {
            setListaDocumentos([])
          }
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          setSubmitting(false)
          __zariContext.loader.close()
        })
    },
    [__zariContext]
  )

  return (
    <Portlet>
      <Portlet.Header title='Consulta De Documentos' />
      <Portlet.Body>
        <Row>
          <Col md={6}>
            <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
              {({ errors, touched, isSubmitting, values, setValues, handleSubmit }) => (
                <>
                  <FormGroups.TipoSocioFormGroup
                    iError={errors.tipoSocio}
                    iTouched={touched.tipoSocio}
                    fIsSubmitting={isSubmitting}
                  />
                  <FormGroups.SocioFormGroup
                    fIsSubmitting={isSubmitting}
                    iError={errors._idSocio}
                    iTouched
                    iValue={values.nombreSocio}
                    setValues={setValues}
                    values={values}
                    vTipoSocio={values.tipoSocio}
                  />
                  <Row>
                    <Col md={12} className='text-right'>
                      <Button disabled={isSubmitting} onClick={handleSubmit}>
                        Consultar
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </Formik>
          </Col>
        </Row>
        {listaDocumentos.map(x => (
          <>
            <Divider title={x.moneda} />
            <Row>
              <Col md={12}>
                <Tables.DocumentosEncontradosTable filas={x.filas} />
              </Col>
            </Row>
          </>
        ))}
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ConsultasCuentasCorrientesPage)
